import { Stack, Typography } from "@mui/material";
import Image from "next/image";

import useCopy from "~/modules/_core/locale";

import errorImage from "~/public/assets/error.svg";

const ServerError500 = () => {
  const { translate } = useCopy();
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Stack spacing={3} alignItems="center">
        <Image
          src={errorImage.src}
          alt="error image"
          objectFit="contain"
          width={440}
          height={280}
        />
        <Typography variant="h6">{translate("serverError")}</Typography>
      </Stack>
    </Stack>
  );
};

export default ServerError500;
